import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0529edcb&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=0529edcb&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=0529edcb&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529edcb",
  null
  
)

export default component.exports